import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select, MenuItem, FormControl, Box, Typography } from '@mui/material';
import { useTheme } from '../contexts/ThemeContext';

const LANGUAGES = {
  ro: {
    name: 'Română',
    flag: '🇷🇴'
  },
  en: {
    name: 'English',
    flag: '🇬🇧'
  }
};

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const { isDarkMode } = useTheme();

  const changeLanguage = (event) => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <FormControl size="small" sx={{ minWidth: 100 }}>
      <Select
        value={i18n.language}
        onChange={changeLanguage}
        sx={{ 
          backgroundColor: 'transparent',
          color: 'inherit',
          '& .MuiSelect-select': { 
            py: 0.5,
            px: 1,
            display: 'flex',
            alignItems: 'center',
            gap: 0.5
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.23)' : 'rgba(0, 0, 0, 0.23)'
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: isDarkMode ? 'rgba(255, 255, 255, 0.4)' : 'rgba(0, 0, 0, 0.4)'
          },
          '& .MuiSvgIcon-root': {
            color: 'inherit'
          }
        }}
        MenuProps={{
          PaperProps: {
            sx: {
              '& .MuiMenuItem-root': {
                color: isDarkMode ? '#fff' : '#000'
              }
            }
          }
        }}
      >
        {Object.entries(LANGUAGES).map(([code, { name, flag }]) => (
          <MenuItem 
            key={code} 
            value={code}
            dense
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 0.5,
              py: 0.5,
              minHeight: 'unset'
            }}
          >
            <Typography component="span" sx={{ fontSize: '1em', lineHeight: 1 }}>
              {flag}
            </Typography>
            <Typography sx={{ fontSize: '0.875em', lineHeight: 1 }}>
              {name}
            </Typography>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default LanguageSelector; 